// extracted by mini-css-extract-plugin
export default {"container":"bb","hidden":"cb","column":"db","headline":"eb"};